import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import styled from 'styled-components';
import {
  fontSize,
  fontWeights,
  maxBreakpointQuery,
  minBreakpointQuery,
  visuallyHidden,
} from '../styles';
import trustpilotLogo from '../images/trustpilot-logo.svg';

const StyledTrustpilotWidget = styled.a`
  display: inline-grid;
  gap: 6px;

  ${minBreakpointQuery.small`
    gap: 8px;
  `}

  ${minBreakpointQuery.large`
    gap: 10px;
  `}
`;

const StyledLogo = styled.img`
  width: 70px;

  ${minBreakpointQuery.small`
    width: 80px;
  `}

  ${minBreakpointQuery.large`
    width: 90px;
  `}
`;

const StyledStars = styled.img`
  width: 100px;

  ${minBreakpointQuery.small`
    width: 120px;
  `}

  ${minBreakpointQuery.large`
    width: 140px;
  `}
`;

const StyledRating = styled.p`
  ${maxBreakpointQuery.small`
    ${visuallyHidden()};
  `}

  ${minBreakpointQuery.small`
    font-family: Arial, sans-serif;
    font-weight: ${fontWeights.medium};
    ${fontSize(14)};
    line-height: 1;
  `}

  ${minBreakpointQuery.large`
    ${fontSize(16)};
  `}
`;

const TrustpilotWidget = ({ ...props }) => {
  const {
    contentfulSitewide: { trustpilotScore },
  } = useStaticQuery(graphql`
    query TrustpilotWidgetQuery {
      contentfulSitewide {
        trustpilotScore
      }
    }
  `);

  let stars = 1;
  let rating = '';

  if (trustpilotScore < 1.2) {
    stars = 1;
    rating = 'Bad';
  } else if (trustpilotScore <= 1.7) {
    stars = 1.5;
    rating = 'Bad';
  } else if (trustpilotScore <= 2.2) {
    stars = 2;
    rating = 'Poor';
  } else if (trustpilotScore <= 2.7) {
    stars = 2.5;
    rating = 'Poor';
  } else if (trustpilotScore <= 3.2) {
    stars = 3;
    rating = 'Average';
  } else if (trustpilotScore <= 3.7) {
    stars = 3.5;
    rating = 'Average';
  } else if (trustpilotScore <= 4.2) {
    stars = 4;
    rating = 'Great';
  } else if (trustpilotScore <= 4.7) {
    stars = 4.5;
    rating = 'Excellent';
  } else if (trustpilotScore <= 5) {
    stars = 5;
    rating = 'Excellent';
  }

  return (
    <StyledTrustpilotWidget
      href={`https://uk.trustpilot.com/review/${process.env.GATSBY_SITE_URL.replace('https://www.', '')}`}
      target="_blank"
      title="View Trustpilot reviews"
      {...props}
    >
      <StyledLogo src={trustpilotLogo} alt="Trustpilot Logo" />
      <StyledStars
        src={`https://cdn.trustpilot.net/brand-assets/4.1.0/stars/stars-${stars}.svg`}
        alt={`${stars} stars`}
      />
      <StyledRating>{rating}</StyledRating>
    </StyledTrustpilotWidget>
  );
};

export default TrustpilotWidget;
